import { render, staticRenderFns } from "./Horario.vue?vue&type=template&id=39cbafae&scoped=true&"
import script from "./Horario.vue?vue&type=script&lang=js&"
export * from "./Horario.vue?vue&type=script&lang=js&"
import style0 from "./Horario.vue?vue&type=style&index=0&id=39cbafae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cbafae",
  null
  
)

export default component.exports